<template lang="pug">
div(:class="currentView == 'chart' ? '': 'chartWrapper'")
    Button.cardBtn.textBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'textBtn' && withRawBtn") {{ toggleViewHint }}
    Button.iconBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'iconBtn' && withRawBtn" :icon="toggleViewHint")
    template(v-if="withCard")
        template(v-if="currentView == 'chart'")
            Card.card-shadow
                pie-chart(
                    v-if="chartData.datacollection.labels.length > 0"
                    :chart-data="chartData.datacollection"
                    :options="chartData.options"
                    :width="chartWidth"
                    :height="chartHeight")
                EmptyPie(
                    v-else
                    :chartTitle="chartTitle"
                    :chartWidth="chartWidth"
                    :chartHeight="chartHeight"
                    :titleDisplay="false")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData")
    template(v-else)
        template(v-if="currentView == 'chart'")
            pie-chart(
                v-if="chartData.datacollection.labels.length > 0"
                :chart-data="chartData.datacollection"
                :options="chartData.options"
                :width="chartWidth"
                :height="chartHeight")
            EmptyPie(
                v-else
                :chartTitle="chartTitle"
                :chartWidth="chartWidth"
                :chartHeight="chartHeight"
                :useGuage="true"
                :titleDisplay="false"
                :legendDisplay="false")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData" :no-data-text="$t('main.tableNoDataText')")
    Spin(size="large" fix v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";
import { getEdgeChartData } from "@/api/monitor.js";
import PieChart from "@/components/pieChart.js";
import numeral from "numeral";
import EmptyPie from "@/components/dashboard/EmptyPie";

export default {
    name: "PieChartWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "chartTitle" },
        titleDisplay: { type: Boolean, default: true },
        chartDataSetLabel: { type: Array, default: () => [] },
        chartDataSetLabelTranslate: { type: Boolean, default: true },
        numeralFormat: { type: String, default: "0.00a" },
        topNSize: { type: Number, default: 5 },

        groupNames: { type: Array, default: () => [] },
        tags: { type: Array, default: () => [] },
        serviceGroupNames: { type: Array, default: () => [] },
        domains: { type: Array, default: () => [] },
        appProfileNames: { type: Array, default: () => [] },
        origins: { type: Array, default: () => [] },
        originHosts: { type: Array, default: () => [] },
        originPorts: { type: Array, default: () => [] },
        latencyStatusNames: { type: Array, default: () => [] },
        edgeNames: { type: Array, default: () => [] },
        slbNames: { type: Array, default: () => [] },
        dateRange: { type: String, default: "" },
        customTimeRange: { type: Array, default: () => [] },

        withCard: { type: Boolean, default: true },
        withPropRawBtn: {},
        chartWidth: { type: Number, default: 600 },
        chartHeight: { type: Number, default: 340 },
        useGuage: { type: Boolean, default: false },
        pieBackgroundColors: {
            type: Array,
            default: () => [["#55b5db", "#a074c4", "#e6cd69", "#d6d6d6", "#55dbbe", "#Cd3f45", "#db7b55"]],
        },
        legendDisplay: { type: Boolean, default: true },
        legendPosition: { type: String, default: "top" },
        legendAlign: { type: String, default: "center" },

        // 放置百分比在圖表中間, 這個位置需要再調整
        withPercentageText: { type: Boolean, default: false },

        apiEndpoint: { type: String, default: "" },
        isGetDataFromStore: { type: Boolean, default: false },
        calculateFormula: {},
        isPointStyle: { type: Boolean, default: false },
    },
    components: { PieChart, EmptyPie },
    watch: {
        "$store.state.userPref.lang": function (newVal, oldVal) {
            this.fillChartData(this.nginxData);
        },
        calculateFormula(oldVal, newVal) {
            // console.log(newVal, oldVal);
            // this.formatString = this.formatNumToString(this.calculateFormula);

            let nginxData = this.calculateFormula;
            this.nginxData = nginxData;
            this.fillChartData(nginxData);
        },
    },
    created() {},
    beforeDestroy() {
        bus.$off("searchChartData", this.getDataAndDraw);
    },
    data() {
        return {
            spinShow: false,
            chartData: {
                datacollection: { labels: [] },
                options: {},
            },
            nginxData: null,
            percentageText: "",
            rawDataTableColumns: [],
            rawDataTableData: [],
            currentView: "chart",
        };
    },
    methods: {
        fillChartData(nginxData) {
            var self = this;

            var datasets = nginxData.data.datasets.map((dataset, index) => {
                return {
                    data: dataset.data,
                    backgroundColor: this.pieBackgroundColors[index],
                };
            });

            // 只有兩個數值的時候才會算百分比
            if (this.withPercentageText && datasets[0].data.length == 2) {
                // 百分比為第一項除總數
                // console.log(datasets[0].data[0]);
                // console.log(datasets[0].data[1]);
                // console.log(datasets[0].data[0] + datasets[0].data[1]);
                let percentage = (datasets[0].data[0] / (datasets[0].data[0] + datasets[0].data[1])) * 100;
                this.percentageText = percentage.toFixed(2) + "%";
            }

            let legendLabel = {};
            if (this.isPointStyle == true) {
                legendLabel = {
                    usePointStyle: true,
                    boxWidth: 8,
                };
            }

            var chartData = {
                datacollection: {
                    labels: nginxData.data.labels,
                    datasets: datasets,
                },
                options: {
                    elements: {
                        arc: {
                            borderWidth: 0,
                        },
                        center: {
                            text: this.percentageText,
                        },
                    },
                    scales: {
                        yAxes: [],
                        xAxes: [],
                    },
                    legend: {
                        display: this.legendDisplay,
                        position: this.legendPosition,
                        // onClick: () => {},
                        align: this.legendAlign,
                        labels: legendLabel,
                    },
                    tooltips: {
                        enabled: true,
                        mode: "single",
                        callbacks: {
                            label: function (tooltipItems, data) {
                                let index = tooltipItems.index;
                                return `${data.labels[index]}: ${numeral(data.datasets[0].data[index]).format(
                                    self.numeralFormat
                                )}`;
                            },
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    height: 200,
                    cutoutPercentage: 75,
                    rotation: this.useGuage ? 1 * Math.PI : 0.5 * Math.PI,
                    circumference: this.useGuage ? 1 * Math.PI : 2 * Math.PI,
                    title: {
                        display: this.titleDisplay,
                        text: this.chartTitle,
                    },
                },
            };

            this.chartData = chartData;
        },
        getDataAndDraw() {
            if (!this.isGetDataFromStore) {
                this.spinShow = true;
                var chartOptions = {
                    chartType: this.chartType,
                    groupNames: this.queryFilter.groupNames,
                    tags: this.queryFilter.tags,
                    serviceGroupNames: this.queryFilter.serviceGroupNames,
                    domains: this.queryFilter.domains,
                    appProfileNames: this.queryFilter.appProfileNames,
                    origins: this.queryFilter.origins,
                    originHosts: this.queryFilter.originHosts,
                    originPorts: this.queryFilter.originPorts,
                    slbNames: this.queryFilter.slbNames,
                    edgeNames: this.queryFilter.edgeNames,
                    latencyStatusNames: this.queryFilter.latencyStatusNames,
                    dateRangeOptions: {
                        index: this.queryFilter.dateRangeOptions.index,
                        customTimeRange: this.queryFilter.dateRangeOptions.customTimeRange,
                    },
                    topNSize: this.topNSize,
                    apiEndpoint: this.apiEndpoint,
                };
                getEdgeChartData(chartOptions).then((nginxData) => {
                    // console.log(nginxData);
                    this.nginxData = nginxData;
                    this.fillChartData(nginxData);
                    this.spinShow = false;
                });
            } else {
                let nginxData = this.calculateFormula;
                this.nginxData = nginxData;
                this.fillChartData(nginxData);
                // return this.calculateFormula;
            }
        },
        toggleCurrentView() {
            if (this.currentView == "chart") {
                this.currentView = "rawDataTable";
                this.rawDataTableColumns = [
                    {
                        title: this.$i18n.t(this.chartTitle),
                        key: "title",
                    },
                    {
                        title: "Value",
                        key: "value",
                    },
                ];
                let dataCollection = this.chartData.datacollection;
                this.rawDataTableData = dataCollection.labels.map((label, i) => {
                    return {
                        title: label,
                        value: numeral(dataCollection.datasets[0].data[i]).format(this.numeralFormat),
                    };
                });
            } else {
                this.currentView = "chart";
            }
        },
    },
    mounted() {
        this.getDataAndDraw();
        bus.$on("searchChartData", this.getDataAndDraw);
    },
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
        withRawBtn() {
            return this.withPropRawBtn !== undefined
                ? this.withPropRawBtn
                : this.$store.getters.getChartConfig.withRawBtn;
        },
        toggleViewHint() {
            if (this.showRawBtnStyle == "textBtn") return this.currentView == "chart" ? "View Raw" : "Back To Chart";
            return this.currentView == "chart" ? "md-eye" : "md-redo";
        },
        // query 參數, 優先使用props, 否則去看store
        queryFilter() {
            var queryFilter = this.$store.state.dashboard.queryFilter;

            // 如果dashboardQueryFilter組件還沒生成, 那就先看store > queryGroupName
            var queryGroupName = this.$store.state.queryGroupName;
            return {
                groupNames:
                    this.groupNames.length > 0
                        ? this.groupNames
                        : queryGroupName !== "all"
                        ? [queryGroupName]
                        : queryFilter.groupNames,
                tags: this.tags.length > 0 ? this.tags : queryFilter.tags,
                serviceGroupNames:
                    this.serviceGroupNames.length > 0 ? this.serviceGroupNames : queryFilter.serviceGroupNames,
                domains: this.domains.length > 0 ? this.domains : queryFilter.serverNames,
                appProfileNames: this.appProfileNames.length > 0 ? this.appProfileNames : queryFilter.appProfileNames,
                origins: this.origins.length > 0 ? this.origins : queryFilter.origins,
                originHosts: this.originHosts.length > 0 ? this.originHosts : queryFilter.originHosts,
                originPorts: this.originPorts.length > 0 ? this.originPorts : queryFilter.originPorts,
                slbNames: this.slbNames.length > 0 ? this.slbNames : queryFilter.slbNames,
                edgeNames: this.edgeNames.length > 0 ? this.edgeNames : queryFilter.edgeNames,
                latencyStatusNames:
                    this.latencyStatusNames.length > 0 ? this.latencyStatusNames : queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.dateRange || queryFilter.dateRangeOptions.index,
                    customTimeRange:
                        this.customTimeRange.length > 0
                            ? customTimeRange
                            : queryFilter.dateRangeOptions.customTimeRange,
                },
            };
        },
    },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/PieChartWrapper.vue